import { cx } from "@unizpay/ui";
import { Link } from "react-router";

export interface TabItem {
  to: string;
  label: string;
  count?: number;
  active: boolean;
}

/** Underlined tab bar. Each tab is a link, so the selection lives in the URL. */
export function Tabs({ label, items }: { label: string; items: TabItem[] }) {
  return (
    <nav aria-label={label} className="overflow-x-auto border-b border-line">
      <ul className="flex gap-5">
        {items.map((t) => (
          <li key={t.to}>
            <Link
              to={t.to}
              aria-current={t.active ? "page" : undefined}
              className={cx(
                "-mb-px flex items-center gap-1.5 border-b-2 py-2 text-sm font-medium whitespace-nowrap",
                t.active
                  ? "border-accent text-accent"
                  : "border-transparent text-fg-muted hover:border-line-strong hover:text-fg",
              )}
            >
              {t.label}
              {t.count !== undefined && (
                <span
                  className={cx(
                    "rounded px-1.5 text-xs tabular-nums",
                    t.active ? "bg-accent/10 text-accent" : "bg-subtle text-fg-muted",
                  )}
                >
                  {t.count}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
